import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import LoadableButton from "../../components/button/LoadableButton";
import { CheckBaseUrlApi, LoginApi } from "../../api/request/auth";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../store/Slices/userSlice";
import { motion } from "framer-motion";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [form] = Form.useForm();
  
  const [initialValues, setInitialValues] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  
  const handleSubmit = async (values) => {
    const params = {
      ...values,
    };
    try {
      setIsLoading(true);
      const { data } = await LoginApi(params);
      if (data?.status) {
        form.resetFields();
        localStorage.setItem("email", values?.email);
        toast.success(data?.message);
        navigate("/otp");
      }
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoading(false);
    }
  };
  
  const checkBaseUrl = async () => {
    try {
      const { data } = await CheckBaseUrlApi();
      if (data?.status) {
        dispatch(setUserDetails({ base_url: data?.base_url }));
      }
    } catch (error) {
      console.error("Error fetching base URL:", error);
    }
  };
  
  useEffect(() => {
    checkBaseUrl();
  }, []);
  
  const formVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={formVariants}
      >
        <div className="text-center mb-10">
          <motion.h1 
            variants={itemVariants}
            className="text-3xl lg:text-4xl font-bold text-gray-800 mb-2"
          >
            Superadmin Login
          </motion.h1>
          <motion.p 
            variants={itemVariants}
            className="text-gray-500 text-base"
          >
            Sign in to manage TrackmyDoc
          </motion.p>
        </div>

        <Form
          layout="vertical"
          autoComplete="off"
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValues}
          className="space-y-6"
          requiredMark={false}
        >
          <motion.div variants={itemVariants}>
            <Form.Item
              label={<span className="font-semibold text-gray-700">Email Address</span>}
              name="email"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: "email", message: "Please input valid email!" },
              ]}
              className="mb-4"
            >
              <Input 
                placeholder="Enter your email" 
                size="large" 
                className="rounded-xl py-3 px-4 border-gray-200 hover:border-primary focus:border-primary focus:shadow-md transition-all duration-300"
              />
            </Form.Item>
          </motion.div>

          <motion.div variants={itemVariants}>
            <Form.Item
              label={<span className="font-semibold text-gray-700">Password</span>}
              name="password"
              rules={[{ required: true, message: "Please input your password!" }]}
              className="mb-2"
            >
              <Input.Password
                placeholder="Enter your password"
                size="large"
                className="rounded-xl py-3 px-4 border-gray-200 hover:border-primary focus:border-primary focus:shadow-md transition-all duration-300"
              />
            </Form.Item>
          </motion.div>

          <motion.div variants={itemVariants} className="flex justify-end mb-6">
            <Link to="/forget_password" className="text-primary font-medium hover:text-secondary hover:underline transition-colors duration-300 text-sm">
              Forgot Password?
            </Link>
          </motion.div>

          <motion.div 
            variants={itemVariants}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            <LoadableButton
              type="submit"
              isLoading={isLoading}
              lable="Sign In"
              loadingLable="Verifying..."
              img="assets/icons/ArrowRight.svg"
              className="btn-primary w-full py-3 h-12 text-white font-semibold text-lg rounded-xl shadow-lg shadow-primary/30 hover:shadow-primary/50 transition-all duration-300 flex justify-center items-center gap-2"
            />
          </motion.div>
        </Form>
      </motion.div>
    </div>
  );
};

export default Login;
